module.exports = __webpack_public_path__ + "font/d595d94bceb01058b3d34957a41ffb4b.otf";